export const DEVICE_MODEL_CREATE_EDIT_OPEN_MODAL = "DEVICE_MODEL_CREATE_EDIT_OPEN_MODAL";

export const DEVICE_MODEL_CREATE_REQUEST = "DEVICE_MODEL_CREATE_REQUEST";
export const DEVICE_MODEL_CREATE_RESULT = "DEVICE_MODEL_CREATE_RESULT";

export const DEVICE_MODEL_UPDATE_REQUEST = "DEVICE_MODEL_UPDATE_REQUEST";
export const DEVICE_MODEL_UPDATE_RESULT = "DEVICE_MODEL_UPDATE_RESULT";

export const DEVICE_MODEL_GET_REQUEST = "DEVICE_MODEL_GET_REQUEST";
export const DEVICE_MODEL_GET_RESULT = "DEVICE_MODEL_GET_RESULT";

export const DEVICE_MODEL_SEARCH_UNIT_TYPES = "DEVICE_MODEL_SEARCH_UNIT_TYPES";
export const DEVICE_MODEL_SEARCH_UNIT_TYPES_RESULT = "DEVICE_MODEL_SEARCH_UNIT_TYPES_RESULT";